import * as types from "../reducers/TicketsReducer";
import storage from "store2";
import moment from "moment";
import { search } from "./SearchActions";

import { formatDate } from "../../config";

export function setTickets(tickets, total_pages) {
  return (dispatch, getState) => {
    // let ticketsStore = getState().tickets;

    // calc total price
    let totalPrice = 0;
    if(tickets.length > 0) {
      totalPrice = tickets.map(ticket => ticket.CardTotalPrice).reduce((a, b) => a + b);
    }

    // dispatch new tickets to current state and length differece to show how many tickets were added/removed
    dispatch(
      _setTickets(
        tickets,
        totalPrice,
        total_pages
      )
    );
  };
}

export function pushTicket( ticket ) {
  return (dispatch, getState) => {
    let tickets = getState().tickets.tickets;
    let newTicketsIDs = getState().tickets.new_tickets_ids;
    
    newTicketsIDs.push(ticket.CardID);

    // add ticket to the start of the array
    tickets.unshift(ticket);

    // calc total price
    let totalPrice = 0;
    if(tickets.length > 0) {
      totalPrice = tickets.map(ticket => ticket.CardTotalPrice).reduce((a, b) => a + b);
    }

    dispatch(_updateTickets(tickets, newTicketsIDs, totalPrice))
  }
}

export function oldifyTicket( id ) {
  return (dispatch, getState) => {
    let ticketsStore = getState().tickets;
    let new_tickets_ids = new Set(ticketsStore.new_tickets_ids);
    new_tickets_ids.delete(id);
    dispatch(_oldifyTicket(Array.from(new_tickets_ids)));
  }
}

export function searchByID(id) {
  return (dispatch, getState) => {
    let ticketsStore = getState().tickets;
    let tickets = ticketsStore.filtered_tickets || ticketsStore.tickets;

    let filteredTickets = tickets.filter(ticket => Number(ticket.CardID) === Number(id));

    dispatch(_setFilteredTickets(filteredTickets, 0, filteredTickets.length, true));
  }
}

export function filterTickets() {
  return (dispatch, getState) => {
    let ticketsStore = getState().tickets;
    let tickets = ticketsStore.tickets;
    let filteredTickets = [];

    let filters = ticketsStore.filters;
    console.log('filters', filters);
    let hasFilterTypes = filters.CardTypeID.length > 0;
    let hasFilterStatus = filters.CardStatusID.length > 0;
    let hasFilterDate = filters.ActionDate;

    if(hasFilterTypes) {
      tickets.forEach(ticket => {
        // check card types
        if(filters.CardTypeID.includes(ticket.CardTypeID)) {
          filteredTickets.push(ticket);
        }
      });
    } else {
      filteredTickets = tickets;
    }

    if(hasFilterStatus) {
      filteredTickets = filteredTickets.filter(ticket => filters.CardStatusID.includes(ticket.CardStatusID))
    }

    if(hasFilterDate) {
      filteredTickets = filteredTickets.filter(ticket => {
        // check date range
        if (filters.ActionDate) {
          let dates = filters.ActionDate;
          let from = moment(formatDate(dates.from));
          let actionDate = moment(formatDate(ticket.ActionDate));
          if (dates.from && dates.to) {
            let to = moment(formatDate(dates.to));
            if (actionDate.isSameOrBefore(to) && actionDate.isSameOrAfter(from)) {
              return true;
            }
          } else {
            if (actionDate.isSame(from)) {
              return true
            }
          }
        }

        return false;
      })
    }
    let totalPrice = 0;
    if(filteredTickets.length > 0) {
      totalPrice = filteredTickets.map(ticket => ticket.CardTotalPrice).reduce((a, b) => a + b);
    }

    dispatch(
      _setFilteredTickets(
        filteredTickets,
        totalPrice,
        filteredTickets.length,
        // filteredTickets.length / ticketsStore.page.lenxgth
      )
    );
  };
}

export function setFilters(filters) {
  return dispatch => {
    dispatch({
      type: types.SET_FILTERS,
      filters
    });

    return dispatch(filterTickets());
  };
}

export function selectPage(id) {
  return dispatch => {
    // ui scroll to top
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })

    // update store with current requested page
    dispatch(_selectPage(id));

    // search again to update with new page
    dispatch(search());
  }
}

export function setPage(id) {
  return dispatch => {
    dispatch(_selectPage(id))
  }
}

export function clearTicketsLoaders() {
  return dispatch => dispatch(_clearTicketsLoaders());
}

function _setTickets(tickets, totalPrice, total_pages) {
  return {
    type: types.SET_TICKETS,
    tickets,
    totalPrice,
    total_pages
  };
}

function _updateTickets( tickets, newTicketsIDs, totalPrice ) {
  return {
    type: types.UPDATE_TICKETS,
    tickets,
    newTicketsIDs,
    totalPrice
  }
}

function _oldifyTicket( new_tickets_ids ) {
  return {
    type: types.OLDIFY_TICKET,
    new_tickets_ids
  }
}

function _setFilteredTickets(filteredTickets, totalPrice, ticketsLength, isByID) {
  return {
    type: types.SET_FILTERED_TICKETS,
    filteredTickets,
    totalPrice,
    ticketsLength,
    isByID
  };
}

function _selectPage(id) {
  return {
    type: types.SELECT_PAGE,
    page: id
  };
}

function _clearTicketsLoaders() {
  return {
    type: types.CLEAR_TICKETS_LOADERS
  };
}
